
export default function(o,small){

  if(small){
    var fontSize = o.fontSizeDef.xs
    var padding = '0.15rem 0.2rem 0.15rem'
  } else {
    var fontSize = o.fontSizeDef.s
    var padding = '0.2rem 0.3rem 0.2rem'
  }

  var div =
    $('<input>')
    .css({
      display: 'inline-block',
      verticalAlign: 'top',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      boxSizing: 'inherit',
      padding: padding,
      fontFamily: 'Helvetica Neue LT W06_85 Heavy',
      textAlign: 'left',
      fontSize: fontSize,
      margin: 0,
      outline: 'none',
      backgroundColor: 'white',
      color: 'rgba(0,0,0,0.9)',
      '-webkit-user-select': 'text',
    })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/input/input.js